import {
  Chip,
  UpdateIconButton,
  formatDate,
  formatMinutes,
  Grid,
  LockedIcon,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StudentServiceTemplateListDto,
  StudentServiceTemplateListResource,
} from "generated/openApi";

import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { studentServiceTemplatePageRoute } from "../StudentServiceTemplatePage/StudentServiceTemplatePage";

export const StudentServiceTemplateTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  studentServiceTemplates: StudentServiceTemplateListDto[];
  listTotal: number | undefined;
  resource: StudentServiceTemplateListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentServiceTemplateListDto>("date"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find(
                  (x) => x.propertyName === pn<StudentServiceTemplateListDto>("serviceType")
                )}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            {/* <TableCell>
              <ListBeProperty
                listProperty={properties.find(
                  (x) => x.propertyName === pn<StudentServiceTemplateListDto>("serviceSubType")
                )}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell> */}
            <TableCell>
              <ListBeProperty
                listProperty={properties.find(
                  (x) => x.propertyName === pn<StudentServiceTemplateListDto>("serviceName")
                )}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>Service Location(s)</TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find(
                  (x) => x.propertyName === pn<StudentServiceTemplateListDto>("durationInMinutes")
                )}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find(
                  (x) => x.propertyName === pn<StudentServiceTemplateListDto>("createdDate")
                )}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.studentServiceTemplates.map((studentServiceTemplateItem) => (
            <TableRow
              key={studentServiceTemplateItem.id}
              onClick={() =>
                navigate({
                  pathname: studentServiceTemplatePageRoute.getPath({
                    id: studentServiceTemplateItem.id,
                    crudMode: "view",
                    screenType: "standard",
                  }),
                })
              }
            >
              <TableCell>{formatDate(studentServiceTemplateItem.date)}</TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center">
                  <Typography variant="inherit">{studentServiceTemplateItem.serviceType}</Typography>
                  {studentServiceTemplateItem?.isForParent && <EscalatorWarningIcon />}
                </Stack>
              </TableCell>
              {/* <TableCell>{studentServiceTemplateItem.serviceSubType}</TableCell> */}
              <TableCell>{studentServiceTemplateItem.serviceName}</TableCell>
              <TableCell>
                {!studentServiceTemplateItem.isServiceLocationForCollege ? (
                  studentServiceTemplateItem.school
                ) : (
                  <Grid container spacing={"sm"}>
                    {studentServiceTemplateItem.colleges?.map((x) => (
                      <Grid key={x} item>
                        <Chip label={x} />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </TableCell>
              <TableCell>{formatMinutes(studentServiceTemplateItem.durationInMinutes)}</TableCell>
              <TableCell>{formatDate(studentServiceTemplateItem.createdDate)}</TableCell>
              <TableCell type="action">
                {studentServiceTemplateItem.isLocked === true && <LockedIcon />}

                {isAuthorized(props.rootPermission, PermissionAction.Update) &&
                  (!studentServiceTemplateItem.isLocked ||
                    isAuthorized(props.rootPermission, PermissionAction.Lock)) && (
                    <UpdateIconButton color="primary"
                      onClick={() =>
                        navigate({
                          pathname: studentServiceTemplatePageRoute.getPath({
                            id: studentServiceTemplateItem.id,
                            crudMode: "edit",
                            screenType: "standard",
                          }),
                        })
                      }
                    />
                  )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
